import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid p-px-5" }
const _hoisted_2 = { class: "p-col-6" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre del plan", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "url" }, "URL", -1)
const _hoisted_7 = { class: "p-inputgroup p-mb-2" }
const _hoisted_8 = { class: "p-inputgroup-addon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-800" }, [
  /*#__PURE__*/_createTextVNode(" SEO friendly, sin acentos, \"ñ\", espacios... "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Antes de cambiarla avisar a it@coderhouse.com para hacer las redirecciones ")
], -1)
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "shortDescription" }, "Descripción Corta", -1)
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "longDescription" }, "Acerca del plan", -1)
const _hoisted_14 = { class: "p-col-6" }
const _hoisted_15 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Dificultad", -1)
const _hoisted_18 = { class: "p-grid p-mb-3" }
const _hoisted_19 = { class: "p-col-6" }
const _hoisted_20 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "laptopRequired" }, "Requiere laptop", -1)
const _hoisted_22 = { class: "p-d-flex p-jc-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "preSale" }, "Preventa", -1)
const _hoisted_24 = { class: "p-col-6" }
const _hoisted_25 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "published" }, "Publicado", -1)
const _hoisted_27 = { class: "p-d-flex p-jc-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "display" }, "Disponible", -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "p-field p-mb-5"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "courseSelector" }, "Carreras asociadas al curso", -1)
const _hoisted_32 = {
  key: 0,
  class: "p-pt-2 p-d-flex p-flex-column"
}
const _hoisted_33 = {
  key: 1,
  class: "p-ml-5 p-mb-5 text-gray-800 text-size-12"
}
const _hoisted_34 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_DifficultySelector = _resolveComponent("DifficultySelector")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ChTag = _resolveComponent("ChTag")!
  const _component_CoursesMultipleSelector = _resolveComponent("CoursesMultipleSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          id: "name",
          type: "text",
          value: _ctx.name,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:name', $event.target.value)))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.educationPlanPath), 1),
          _createVNode(_component_InputText, {
            id: "url",
            type: "text",
            value: _ctx.path,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:path', $event.target.value)))
          }, null, 8, ["value"])
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_Textarea, {
          id: "shortDescription",
          type: "text",
          value: _ctx.shortDescription,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:shortDescription', $event.target.value))),
          rows: "3",
          cols: "100",
          autoResize: true
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_Textarea, {
          id: "longDescription",
          type: "text",
          value: _ctx.longDescription,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:longDescription', $event.target.value))),
          rows: "4",
          cols: "100",
          autoResize: true
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (!_ctx.isCareerPlan(_ctx.educationPlan) && (_ctx.routeName === _ctx.EducationRouteNames.CONTENT_COURSES_CREATE_ABOUT || _ctx.routeName === _ctx.EducationRouteNames.CONTENT_COURSES_DETAIL_GENERAL_INFO))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_DifficultySelector, {
                style: {"width":"50%"},
                modelValue: _ctx.difficulty,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:difficulty', $event.value))),
                class: "p-pt-0 p-pb-0"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.config,
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:config', _ctx.toggleElementsFromArray(_ctx.EducationPlanConfiguration.LaptopRequired, _ctx.config)))),
              value: _ctx.EducationPlanConfiguration.LaptopRequired
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.config,
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:config', _ctx.toggleElementsFromArray(_ctx.EducationPlanConfiguration.Earlybird, _ctx.config)))),
              value: _ctx.EducationPlanConfiguration.Earlybird
            }, null, 8, ["modelValue", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.published,
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:published', !_ctx.published))),
              binary: true,
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.display,
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:display', !_ctx.display))),
              binary: true
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      (!_ctx.isCareerPlan(_ctx.educationPlan) && (_ctx.routeName === _ctx.EducationRouteNames.CONTENT_COURSES_CREATE_ABOUT || _ctx.routeName === _ctx.EducationRouteNames.CONTENT_COURSES_DETAIL_GENERAL_INFO))
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            (_ctx.educationPlan)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  (_ctx.careerPlans && _ctx.careerPlans.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.careerPlans, (career) => {
                          return (_openBlock(), _createBlock(_component_ChTag, {
                            style: {"width":"75%"},
                            key: career,
                            class: "p-ml-5 p-mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(career.information.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "No hay carreras asociadas al curso"))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCareerPlan(_ctx.educationPlan) || _ctx.routeName === _ctx.EducationRouteNames.CONTENT_CAREERS_CREATE_ABOUT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createVNode(_component_CoursesMultipleSelector, {
              placeholder: "Cursos que componen la carrera",
              label: "Cursos asignados a la carrera",
              helperText: "Ingrese los cursos en el orden correspondiente.",
              coursePlans: _ctx.coursePlans,
              modelValue: _ctx.careerCourses,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:careerCourses', $event)))
            }, null, 8, ["coursePlans", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}